<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1 style="display:inline-block">Lesson Plans</h1>
    <button class="btn btn-primary"  style="display:inline-block;margin-left:20px" (click)="refresh()">Refresh Data</button>
    <button class="btn btn-primary"  style="display:inline-block;margin-left:20px" (click)="clearFilter()">Clear Filter</button>
    <br><br>
    <table class="table table-bordered">
        <thead>
          <tr>
            <th>Scenario Name</th>
            <th>Player Name</th>
            <th>Date</th>
            <th>Time</th>
            <th>Millis</th>
            <th>Pos</th>
            <th>nbeforeRender</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let logEntry of logsFlattenedDisplay">
            <ng-container *ngFor="let log of logEntry.log">
              <tr>
                <td>
                  {{ logEntry.scenarioname }}
                  <i class="bi bi-trash" style="color:orange" (click)="deleteScenario(logEntry.scenarioname)"></i>
                </td>
                <td>{{ logEntry.playername }}</td>
                <td>
                  {{ logEntry.date }}
                  <i class="bi bi-filter" style="color:blue"  (click)="filterDateAndScenario(logEntry.scenarioname,logEntry.date)"></i>
                </td>
                <td>{{ logEntry.time }}</td>
                <td>{{ log.millis }}</td>
                <td>{{ log.pos }}</td>
                <td>{{ log.nbeforeRender }}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>

      <!-- <br>
    <table>
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of renderlogs | keyvalue">
            <td>{{ item.key }}</td>
            <td>{{ item.value | json}}</td>
          </tr>
        </tbody>
      </table> -->

      <!-- <br>
    {{renderlogs | json}}
    <hr>
    {{logsFlattened | json}} -->
</div>